import { render, staticRenderFns } from "./StockLogo.vue?vue&type=template&id=65be0be0&scoped=true"
import script from "./StockLogo.vue?vue&type=script&lang=js"
export * from "./StockLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@5.2.7_prettier@2.8.8_vue-template-compiler@2.6.11_webpack@5.75.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65be0be0",
  null
  
)

export default component.exports